import {combineReducers} from 'redux';

import adminsReducer from './adminsReducer';
import buildingsReducer from './buildingsReducer';
import cardsReducer from './cardsReducer';
import customersReducer from './customersReducer';
import elevatorsReducer from './elevatorsReducer';
import entrancesReducer from './entrancesReducer';
import garagesReducer from './garagesReducer';
import modalReducer from './modalReducer';
import paymentsReducer from './paymentsReducer';
import pdfReportsReducer from './pdfReportsReducer';
import reportsReducer from './reportsReducer';
import toastsReducer from './toastsReducer';
import userReducer from './userReducer';
import supervisorsReducer from './supervisorReducer';

const rootReducer = combineReducers({
  admins: adminsReducer,
  supervisors: supervisorsReducer,
  buildings: buildingsReducer,
  cards: cardsReducer,
  customers: customersReducer,
  elevators: elevatorsReducer,
  entrances: entrancesReducer,
  garages: garagesReducer,
  modal: modalReducer,
  payments: paymentsReducer,
  pdfReports: pdfReportsReducer,
  reports: reportsReducer,
  toasts: toastsReducer,
  user: userReducer,
});

export default rootReducer;
